import * as React from 'react';
import { IconProps } from '../types';

const IcOther = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M12.74 11.043h-.718v-7.89A2.155 2.155 0 0 0 9.87 1H7.957a2.155 2.155 0 0 0-2.153 2.152v7.891h-.717A3.591 3.591 0 0 0 1.5 14.63v4.783A3.591 3.591 0 0 0 5.087 23h7.652a3.591 3.591 0 0 0 3.587-3.587V14.63a3.591 3.591 0 0 0-3.587-3.587Zm-5.5-7.89c0-.396.32-.718.716-.718H9.87c.395 0 .717.322.717.717v5.022H7.239V3.152Zm0 6.456h3.347v1.434H7.239V9.61Zm7.651 9.804a2.155 2.155 0 0 1-2.152 2.152H5.087a2.155 2.155 0 0 1-2.152-2.152V14.63c0-1.186.965-2.152 2.152-2.152H12.739c1.187 0 2.152.966 2.152 2.152v4.783Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M12.739 13.913H5.087a.717.717 0 0 0-.718.717v4.783c0 .396.322.717.718.717h7.652a.717.717 0 0 0 .717-.717V14.63a.717.717 0 0 0-.717-.717Zm-.718 4.783H5.804v-3.348h6.217v3.348ZM23.483 22.127l-.645-2.904a2.489 2.489 0 0 0-1.73-1.86v-4.885h1.674a.717.717 0 0 0 .718-.717V3.152A2.155 2.155 0 0 0 21.348 1h-1.913a2.155 2.155 0 0 0-2.152 2.152v8.609c0 .396.32.717.717.717h1.674v4.886a2.489 2.489 0 0 0-1.73 1.86l-.644 2.903c-.1.447.241.873.7.873h4.782c.459 0 .8-.425.7-.873ZM18.717 3.152c0-.395.322-.717.718-.717h1.913c.395 0 .717.322.717.717v5.022h-3.348V3.152Zm0 7.891V9.61h3.348v1.434h-3.348Zm.177 10.522.452-2.03c.11-.494.54-.84 1.045-.84.506 0 .936.346 1.046.84l.451 2.03h-2.994Z"
    />
  </svg>
);

export default IcOther;
